import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  AfterContentChecked
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { CitietouristicService } from 'src/app/api/tourism/citietouristic.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { ServicehotelExtendsComponent } from 'src/app/config/servicehotel/servicehotel-extends/servicehotel-extends.component';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import { constants } from 'src/app/constants';
import { TourService } from 'src/app/api/tourism/tour.service';
import { debounce } from 'lodash';
import { HotelInformationExtendsComponent } from '../../hotel/hotel-information-extends/hotel-information-extends.component';
import { HttpHeaders } from '@angular/common/http';
import SwalAlert from 'src/app/utils/swalalert';
import { OfferService } from 'src/app/api/tourism/offer.service';
import { CategorypackagetourExtendsComponent } from 'src/app/config/categorypackagetour/categorypackagetour-extends/categorypackagetour-extends.component';
declare var $: any;

@Component({
  selector: 'app-packagetour-form',
  templateUrl: './packagetour-form.component.html',
  styleUrls: ['./packagetour-form.component.css']
})
export class PackagetourFormComponent implements OnInit, AfterContentChecked {
  @ViewChild(ServicehotelExtendsComponent) ServicehotelExtendsComponent: any;
  @ViewChild(CategorypackagetourExtendsComponent)
  CategorypackagetourExtendsComponent: any;
  @ViewChild(HotelInformationExtendsComponent)
  HotelInformationExtendsComponent: any;

  branchofficeSlug: string = '';
  nameMenu: string = 'information_general';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  citiestouristic: any;
  packagecategories: any;
  templates_packages: any;
  typepackages: any;
  typepricespackage: any;

  cityMultiSelected: any = 1;
  imageUrl: any = null;
  fileUrlImage: any = null;
  selectedPdfPortada: any | null = null;

  // set values default
  package_typeprice_tour: number = constants.package_typeprice_tour;
  package_typeprice_tourandhotel: number =
    constants.package_typeprice_tourandhotel;
  package_typeprice_multicity: number = constants.package_typeprice_multicity;

  // array variables
  specialoffers: any = [];
  detail_tours: any = [];
  detail_services: any = [];
  detail_hotels: any = [];
  detail_multicity: any = [];

  citiestouristic_multi: any;

  // total variables
  total_tour: any = 0;
  total_additional: any = 0;
  total_service: any = 0;
  total_flight: any = 0;
  total_tour_corporate: any = 0;
  total_multicity: any = 0;

  // packageTourPriceSelected: any = constants.packageTourPriceSelected;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private packagetourService: PackagetourService,
    private citieTouristicService: CitietouristicService,
    private tourService: TourService,
    private offerService: OfferService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
    private changeDetector: ChangeDetectorRef,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      typepackage_id: ['', [Validators.required]],
      packagetourcategory_id: ['', [Validators.required]],
      citietouristic_id: ['', [Validators.required]],
      packagetourtypeprice_id: [
        constants.packageTourPriceSelected,
        [Validators.required]
      ],
      specialoffers_id: [null],
      is_special_offer: [false],
      is_show_web: [false],
      include: [''],
      min_pax: [null],
      description_room: [null],
      include_flight: [false],
      is_services: [false],
      // flight_baggage: ["Tarifa básica/bolso o mochila de 8kg"],
      flight_baggage: [null],
      url_flight: [null],
      total_flight: [0],
      total_tours: [0],
      total_additional: [0],
      url_document: [null],
      templates_detailpackages_id: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    // set initial values =============
    this.getTemplatesPackage();
    this.getTypePackage();
    this.getPackageCategory();
    this.getCitieTouristic();
    this.getTypePricePackage();
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.packagetourService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          description: _item.description,
          typepackage_id: _item.typepackage_id,
          packagetourcategory_id: _item.packagetourcategory_id,
          citietouristic_id: _item.citietouristic_id,
          packagetourtypeprice_id: _item.packagetourtypeprice_id,
          specialoffers_id: _item.specialoffers_id,
          is_special_offer: _item.is_special_offer,
          is_show_web: _item.is_show_web,
          include: _item.include,
          min_pax: _item.min_pax,
          description_room: _item.description_room,
          include_flight: _item.include_flight,
          is_services: _item.is_services,
          flight_baggage: _item.flight_baggage,
          url_flight: _item.url_flight,
          total_flight: _item.total_flight,
          total_tours: _item.total_tours,
          total_additional: _item.total_additional,
          url_document: _item.url_document,
          templates_detailpackages_id: _item.templates_detailpackages_id
        });

        this.detail_tours = _item.itinerary_tour;
        this.detail_services = _item.detail_services;
        this.detail_hotels = _item.detail_hotels;
        this.detail_multicity = _item.detail_multicity;
        this.total_flight = _item.total_flight;
        this.recalculateTotalTour();
        if (_item.is_special_offer) {
          this.changeSpecialOffer(_item.specialoffers_id);
        }
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  // FUNCTIONS LOADS DATAS
  getTemplatesPackage() {
    this.packagetourService.getTemplatesPackage().subscribe({
      next: (data: any) => {
        this.templates_packages = data.results;
        if (!this.isEdit) {
          let val_template = null;
          for (let i in this.templates_packages) {
            if (this.templates_packages[i].is_principal) {
              val_template = this.templates_packages[i].id;
            }
          }
          this.item.patchValue({
            templates_detailpackages_id: val_template
          });
        }
      }
    });
  }

  getTypePackage() {
    this.packagetourService.allTypePackage().subscribe({
      next: (data: any) => {
        this.typepackages = data.results;
      }
    });
  }

  getPackageCategory() {
    this.packagetourService.allCategoryPackage().subscribe({
      next: (data: any) => {
        this.packagecategories = data.results;
      }
    });
  }

  getTypePricePackage() {
    this.packagetourService.allTypePricePackage().subscribe({
      next: (data: any) => {
        this.typepricespackage = data.results;
      }
    });
  }

  getCitieTouristic() {
    this.citieTouristicService.all().subscribe({
      next: (data: any) => {
        this.citiestouristic = data.results;
        this.citiestouristic_multi = data.results;
      }
    });
  }

  changeSpecialOffer(offer_id = null) {
    let val_ = this.item.value.is_special_offer;
    if (val_) {
      this.offerService.all().subscribe({
        next: (data: any) => {
          this.specialoffers = data.results;
          if (offer_id == null) {
            this.item.patchValue({
              specialoffers_id: this.specialoffers[0].id
            });
          } else {
            this.item.patchValue({
              specialoffers_id: offer_id
            });
          }
        }
      });
    } else {
      this.item.patchValue({
        specialoffers_id: null
      });
      this.specialoffers = [];
    }
  }

  changePackageTourPrice() {
    // console.log(this.item.value.packagetourtypeprice_id);
    this.recalculateTotalTour();
  }

  // SOLO TOURS ============================

  selectedTourSearch(item_: any) {
    if (this.toolsService.notExistObjInArr(item_, this.detail_tours)) {
      let position_ = this.detail_tours.length + 1;
      item_.itinerary_id = null;
      item_.position = position_;
      this.detail_tours.push(item_);
      this.recalculateTotalTour();
    } else {
      this.alertifyMsg.warning(
        'El tour ' + item_.description + ' ya se encuentra agregado'
      );
    }
  }

  changeTourPricePackage(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_tours[index].price_package = value_;
      this.recalculateTotalTour();
    }
  }

  changeTourPositionPackage(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_tours[index].position = value_;
    }
  }

  removeTourPackage(id: any, index: any) {
    this.detail_tours.splice(index, 1);
    this.recalculateTotalTour();
  }

  includeFlight() {
    this.total_flight = 0;
    this.fileUrlImage = null;
    this.item.patchValue({
      url_flight: null
    });
    this.recalculateTotalTour();
  }

  changeTotalFLight(param: any): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.total_flight = value_;
      this.recalculateTotalTour();
    }
  }

  includeServices() {
    this.total_service = 0;
    this.detail_services = [];
    this.recalculateTotalTour();
  }

  recalculateTotalTour() {
    let total_ = 0;
    let total_corp_ = 0;
    for (let i in this.detail_tours) {
      total_ = total_ + Number(this.detail_tours[i].price_package);
      total_corp_ = total_corp_ + Number(this.detail_tours[i].price_corporate);
    }
    this.total_tour_corporate = Number(total_corp_).toFixed(2);
    this.total_tour = Number(total_).toFixed(2);
    //  ========= SERVICES
    let total_service_ = 0;
    for (let i in this.detail_services) {
      this.detail_services[i].subtotal =
        Number(this.detail_services[i].quantity) *
        Number(this.detail_services[i].price);
      total_service_ =
        Number(total_service_) + this.detail_services[i].subtotal;
    }
    this.total_service = total_service_;
    this.validateHotelAndTour();
    this.recalculateTotalMultiCity();
  }

  validateHotelAndTour() {
    if (
      this.item.value.packagetourtypeprice_id ==
      this.package_typeprice_tourandhotel
    ) {
      for (let i in this.detail_hotels) {
        this.recalculateHotelPriceFinal(i);
      }
    }
  }

  // SERVICES  ============================
  selectedServiceSearch(item_: any) {
    if (this.toolsService.notExistObjInArr(item_, this.detail_services)) {
      item_.observation = null;
      item_.quantity = 1;
      item_.price = item_.price_sale;
      item_.subtotal = Number(1 * item_.price_sale).toFixed(2);
      this.detail_services.push(item_);
      this.recalculateTotalService();
    } else {
      this.alertifyMsg.warning(
        'El servicio ' + item_.description + ' ya se encuentra agregado'
      );
    }
  }

  changeServiceQuantityPackage(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_services[index].quantity = value_;
      this.recalculateSubtotalService(index);
    }
  }

  changeServicePricePackage(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_services[index].price = value_;
      this.recalculateSubtotalService(index);
    }
  }

  recalculateSubtotalService(index: number) {
    this.detail_services[index].subtotal = Number(
      this.detail_services[index].quantity * this.detail_services[index].price
    ).toFixed(2);
    this.recalculateTotalService();
  }

  recalculateTotalService() {
    let total_ = 0;
    for (let i in this.detail_services) {
      total_ = total_ + Number(this.detail_services[i].subtotal);
    }
    // console.log(total_);
    this.total_service = total_;
    if (this.detail_hotels.length > 0) {
      for (let j in this.detail_hotels) {
        this.recalculateHotelPriceFinal(j);
      }
    }
  }

  removeServicePackage(id: any, index: any) {
    this.detail_services.splice(index, 1);
    this.recalculateTotalService();
  }

  // HOTEL Y TOURS ============================

  selectedHotelSearch(item_: any) {
    let packagetourtypeprice_id_ = this.item.value.packagetourtypeprice_id;
    if (packagetourtypeprice_id_ == this.package_typeprice_tourandhotel) {
      if (this.toolsService.notExistObjInArr(item_, this.detail_hotels)) {
        item_.itinerary_id = null;
        item_.is_principal = false;
        item_.nights = 1;
        item_.additional = null;
        item_.discount = null;
        item_.is_outstanding = false;
        item_.price_final_package = (
          Number(this.total_service) +
          Number(this.total_flight) +
          Number(this.total_tour) +
          Number(item_.price_package * item_.nights)
        ).toFixed(2);
        if (this.detail_hotels.length == 0) {
          item_.is_principal = true;
        }

        this.detail_hotels.push(item_);
      } else {
        this.alertifyMsg.warning(
          'El hotel ' + item_.tradename + ' ya se encuentra agregado'
        );
      }
    }

    // multi cyty data hotels

    if (packagetourtypeprice_id_ == this.package_typeprice_multicity) {
      let val_index_principal = false;
      let is_exist = false;
      let index_city_: any;
      if (this.detail_multicity.length > 0) {
        for (let i in this.detail_multicity) {
          let detail_ = this.detail_multicity[i];
          if (detail_.citietouristic_id == item_.citietouristic_id) {
            if (detail_['detail_hotels'].length == 0) {
              val_index_principal = true;
            }
            if (
              this.toolsService.notExistObjInArr(
                item_,
                detail_['detail_hotels']
              )
            ) {
              is_exist = true;
              index_city_ = i;
              break;
            } else {
              this.alertifyMsg.warning(
                'El hotel ' +
                  item_.description +
                  ' ya se encuentra agregado en la lista de la ciudad de ' +
                  detail_.name_city
              );
            }
          }
        }
        if (is_exist) {
          item_.itinerary_id = null;
          item_.is_principal = false;
          item_.nights = 1;
          item_.additional = null;
          item_.discount = null;
          item_.is_outstanding = false;
          if (val_index_principal) {
            item_.is_principal = true;
          }
          this.detail_multicity[index_city_]['detail_hotels'].push(item_);
          this.recalculateTotalMultiCity();
        }
      } else {
        this.alertifyMsg.warning(
          'Debe agregar al menos una ciudad para agregar hoteles'
        );
      }
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  changeHotelNights(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_hotels[index].nights = value_;
      this.recalculateHotelPriceFinal(index);
    }
  }

  changeHotelPricePackage(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_hotels[index].price_package = value_;
      this.recalculateHotelPriceFinal(index);
    }
  }

  changeHotelAdditional(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      if (_.isEmpty(value_)) {
        value_ = null;
      }
      this.detail_hotels[index].additional = value_;
      this.recalculateHotelPriceFinal(index);
    }
  }

  changeHotelDiscount(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      if (_.isEmpty(value_)) {
        value_ = null;
      }
      this.detail_hotels[index].discount = value_;
      this.recalculateHotelPriceFinal(index);
    }
  }

  changePrincipalHotel(index: number) {
    for (let i in this.detail_hotels) {
      this.detail_hotels[i].is_principal = false;
    }
    this.detail_hotels[index].is_principal = true;
  }

  changeOutstandingHotel(index: number) {
    if (this.detail_hotels[index].is_outstanding) {
      this.detail_hotels[index].is_outstanding = false;
    } else {
      this.detail_hotels[index].is_outstanding = true;
    }
  }

  removeHotel(index: any, tradename: any) {
    this.detail_hotels.splice(index, 1);
    this.alertifyMsg.warning('El hotel ' + tradename + ' ha sido removido');
  }

  recalculateHotelPriceFinal(index: any) {
    let price_final_ =
      Number(this.total_service) +
      Number(this.total_tour) +
      Number(
        this.detail_hotels[index].nights *
          this.detail_hotels[index].price_package
      ) +
      Number(this.detail_hotels[index].additional) -
      Number(this.detail_hotels[index].discount) +
      Number(this.total_flight);
    this.detail_hotels[index].price_final_package = Number(
      price_final_
    ).toFixed(2);
  }

  // MULTI CIUDADES ============================

  addMultiCity() {
    let city_ = this.toolsService.searchArrById(
      this.cityMultiSelected,
      this.citiestouristic_multi
    );

    city_.name_city = city_.description;
    city_.citietouristic_id = city_.id;
    city_.detail_hotels = [];

    if (this.toolsService.notExistObjInArr(city_, this.detail_multicity)) {
      this.detail_multicity.push(city_);
    } else {
      this.alertifyMsg.warning(
        'La ciudad' + city_.description + ' ya se encuentra agregado'
      );
    }
  }
  removeMultiCity(index: any, name_city: any) {
    this.detail_multicity.splice(index, 1);
    this.alertifyMsg.warning('La ciudad ' + name_city + ' ha sido removido');
    this.recalculateTotalMultiCity();
  }

  changeOutstandingHotelCity(index_city: number, index: number) {
    if (
      this.detail_multicity[index_city]['detail_hotels'][index].is_outstanding
    ) {
      this.detail_multicity[index_city]['detail_hotels'][
        index
      ].is_outstanding = false;
    } else {
      this.detail_multicity[index_city]['detail_hotels'][
        index
      ].is_outstanding = true;
    }
  }

  changeHotelNightsCity(param: any, index_city: number, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_multicity[index_city]['detail_hotels'][index].nights = value_;
      this.recalculateTotalMultiCity();
    }
  }

  changeHotelPricePackageCity(
    param: any,
    index_city: number,
    index: number
  ): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_multicity[index_city]['detail_hotels'][
        index
      ].price_package = value_;
      this.recalculateTotalMultiCity();
    }
  }

  changeHotelAdditionalCity(
    param: any,
    index_city: number,
    index: number
  ): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      if (_.isEmpty(value_)) {
        value_ = null;
      }
      this.detail_multicity[index_city]['detail_hotels'][
        index
      ].additional = value_;
      this.recalculateTotalMultiCity();
    }
  }

  changeHotelDiscountCity(param: any, index_city: number, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      if (_.isEmpty(value_)) {
        value_ = null;
      }
      this.detail_multicity[index_city]['detail_hotels'][
        index
      ].discount = value_;
      this.recalculateTotalMultiCity();
    }
  }

  changePrincipalHotelCity(index_city: number, index: number) {
    for (let i in this.detail_multicity[index_city]['detail_hotels']) {
      this.detail_multicity[index_city]['detail_hotels'][
        i
      ].is_principal = false;
    }
    this.detail_multicity[index_city]['detail_hotels'][
      index
    ].is_principal = true;
    this.recalculateTotalMultiCity();
  }

  removeHotelCity(index_city: number, index: any, tradename: any) {
    this.detail_multicity[index_city]['detail_hotels'].splice(index, 1);
    this.alertifyMsg.warning(
      'El hotel ' +
        tradename +
        ' ha sido removido de la lista ciudad ' +
        this.detail_multicity[index_city].name_city
    );
    this.recalculateTotalMultiCity();
  }

  recalculateTotalMultiCity() {
    let total_multicity_ = 0;
    for (let index_city in this.detail_multicity) {
      for (let index_hotel in this.detail_multicity[index_city][
        'detail_hotels'
      ]) {
        if (
          this.detail_multicity[index_city]['detail_hotels'][index_hotel]
            .is_principal
        ) {
          let hotel_ = this.detail_multicity[index_city]['detail_hotels'][
            index_hotel
          ];
          total_multicity_ =
            total_multicity_ +
            Number(hotel_.nights * hotel_.price_package) +
            Number(hotel_.additional) -
            Number(hotel_.discount);
        }
      }
    }
    this.total_multicity = (
      Number(this.total_tour) +
      Number(this.total_flight) +
      Number(total_multicity_)
    ).toFixed(2);
  }

  showHotel(item_: any) {
    let data: any = {};
    data.hotel_data = item_;
    this.HotelInformationExtendsComponent.init(data);
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_flight: null
      });
    };
    reader.readAsDataURL(file);
  }

  onFileSelectedPdfPortada(event: any): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (this.validateSizePdfPortada(file)) {
        this.selectedPdfPortada = file;
      }
    } else {
      this.selectedPdfPortada = null;
      (<any>$('#file_pdf')).val(null);
      // alert('Por favor, seleccione un archivo PDF.');
      this.alert.warning('Por favor, seleccione un archivo PDF.');
    }
  }

  validateSizePdfPortada(file: any, isMulti: boolean = false) {
    const maxSize = 1.5 * 1024 * 1024; // 1.5MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_file) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (1.5 MB). Elija un archivo más pequeño; ó reduzca el tamaño del archivo.',
          10
        );
        return false;
      }
    }

    return true;
  }

  removeFilePdfPortada() {
    this.item.patchValue({
      url_document: null
    });
  }

  onSubmit() {
    this.submitted = true;
    this.item.patchValue({
      total_flight: this.total_flight,
      total_tours: this.total_tour,
      total_additional: this.total_additional
    });

    if (this.item.invalid) {
      return;
    }

    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      // data.detail_tours = this.detail_tours;
      // data.detail_services = this.detail_services;
      // data.detail_hotels = this.detail_hotels;
      // data.detail_multicity = this.detail_multicity;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      formData.append('item', JSON.stringify(data));
      formData.append('detail_tours', JSON.stringify(this.detail_tours));
      formData.append('detail_services', JSON.stringify(this.detail_services));
      formData.append('detail_hotels', JSON.stringify(this.detail_hotels));
      formData.append(
        'detail_multicity',
        JSON.stringify(this.detail_multicity)
      );
      formData.append('url_flight', this.fileUrlImage);
      formData.append('url_document', this.selectedPdfPortada);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.packagetourService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.editData();
          }
        });
      } else {
        this.packagetourService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.routerBack();
          }
        });
      }
    }
  }

  validate() {
    if (this.detail_tours.length == 0) {
      this.alertifyMsg.warning(
        'Debe seleccionar al menos 1 TOURS para poder asignar el precio al paquete turístico'
      );
      return false;
    } else {
      for (let i in this.detail_tours) {
        let _item = this.detail_tours[i];
        let _tour_price_package = this.el.nativeElement.querySelector(
          '#tour_price_package' + i
        );
        if (Number(_item.price_package) == 0 || _.isNull(_item.price_package)) {
          this.alertifyMsg.warning(
            'El precio paquete del tour ' +
              _item.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          this.renderer.selectRootElement(_tour_price_package).focus();
          return false;
        }
      }
    }

    // HOTEL AND TOURS
    if (
      this.item.value.packagetourtypeprice_id ==
      this.package_typeprice_tourandhotel
    ) {
      if (_.isNull(this.item.value.min_pax)) {
        this.alertifyMsg.warning(
          'Debe especificar el N° PAX mínimo para el paquete'
        );
        let element_ = this.el.nativeElement.querySelector('#item_min_pax');
        this.renderer.selectRootElement(element_).focus();
        return false;
      }
      if (_.isNull(this.item.value.description_room)) {
        this.alertifyMsg.warning(
          'Debe especificar el tipo de habitación para el paquete'
        );
        let element_ = this.el.nativeElement.querySelector(
          '#item_description_room'
        );
        this.renderer.selectRootElement(element_).focus();
        return false;
      }

      if (this.detail_hotels.length > 0) {
        for (let i in this.detail_hotels) {
          let hotel_ = this.detail_hotels[i];
          let element_;
          element_ = this.el.nativeElement.querySelector('#hotel_nights' + i);
          if (Number(hotel_.nights) == 0 || _.isNull(hotel_.nights)) {
            this.alertifyMsg.warning(
              'El n° de noches del hotel ' +
                hotel_.tradename +
                ' no puede ser igual a cero o estar vacío.'
            );
            this.renderer.selectRootElement(element_).focus();
            return false;
          }
          // ...............
          element_ = this.el.nativeElement.querySelector(
            '#hotel_price_package' + i
          );
          if (
            Number(hotel_.price_package) == 0 ||
            _.isNull(hotel_.price_package)
          ) {
            this.alertifyMsg.warning(
              'El precio paquete del hotel ' +
                hotel_.tradename +
                ' no puede ser igual a cero o estar vacío.'
            );
            this.renderer.selectRootElement(element_).focus();
            return false;
          }
        }
      } else {
        this.alertifyMsg.warning(
          'Debe seleccionar al menos 1 hotel para el precio HOTEL + TOURS'
        );
        return false;
      }
    }

    // MULTI CIUDADES ============================

    if (
      this.item.value.packagetourtypeprice_id ==
      this.package_typeprice_multicity
    ) {
      if (this.detail_multicity.length >= 2) {
        for (let index_city in this.detail_multicity) {
          let city_ = this.detail_multicity[index_city];
          if (city_['detail_hotels'].length > 0) {
            for (let index_hotel in this.detail_multicity[index_city][
              'detail_hotels'
            ]) {
              let hotel_ = this.detail_multicity[index_city]['detail_hotels'][
                index_hotel
              ];
              let _element_hotel_nights = this.el.nativeElement.querySelector(
                '#hotel_nights' + index_city + index_hotel
              );
              if (Number(hotel_.nights) == 0 || _.isNull(hotel_.nights)) {
                this.alertifyMsg.warning(
                  'El n° de noches del hotel ' +
                    hotel_.tradename +
                    ' no puede ser igual a cero o estar vacío.'
                );
                this.renderer.selectRootElement(_element_hotel_nights).focus();
                return false;
              }
              let _element_hotel_price_package = this.el.nativeElement.querySelector(
                '#hotel_price_package' + index_city + index_hotel
              );
              if (
                Number(hotel_.price_package) == 0 ||
                _.isNull(hotel_.price_package)
              ) {
                this.alertifyMsg.warning(
                  'El precio paquete del hotel ' +
                    hotel_.tradename +
                    ' no puede ser igual a cero o estar vacío.'
                );
                this.renderer
                  .selectRootElement(_element_hotel_price_package)
                  .focus();
                return false;
              }
            }
          } else {
            this.alertifyMsg.warning(
              'Debe agregar al menos 1 hotel para la ciudad ' + city_.name_city
            );
            return false;
          }
        }
      } else {
        this.alertifyMsg.warning(
          'Debe agregar al menos 2 CIUDADES para el tipo de precio seleccionado'
        );
        return false;
      }
    }

    if (
      this.item.value.packagetourtypeprice_id ==
        this.package_typeprice_multicity ||
      this.item.value.packagetourtypeprice_id ==
        this.package_typeprice_tourandhotel
    ) {
      if (this.item.value.include_flight) {
        if (this.total_flight == 0 || this.total_flight == '') {
          this.alertifyMsg.warning(
            'El costo total del VUELO por persona no puede estar vacío'
          );
          (<any>$('#total_flight')).focus();
          return false;
        }

        if (
          this.item.value.flight_baggage == '' ||
          this.item.value.flight_baggage == null
        ) {
          this.alertifyMsg.warning(
            'El detalle de equipaje de vuelo no puede estar vacío'
          );
          (<any>$('#flight_baggage')).focus();
          return false;
        }
      }
    }


    // SOLO TOURS ============================
    if (
      this.item.value.packagetourtypeprice_id == this.package_typeprice_tour
    ) {
      if (_.isNull(this.item.value.min_pax)) {
        this.alertifyMsg.warning(
          'Debe especificar el N° PAX mínimo para el paquete'
        );
        let element_ = this.el.nativeElement.querySelector('#item_min_pax');
        this.renderer.selectRootElement(element_).focus();
        return false;
      }
    }

    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    (<any>$('#item_description')).focus();
  }

  cancel() {
    this.routerBack();
  }

  routerBack() {
    this.router.navigate([this.branchofficeSlug + '/turismo/paquetes/lista']);
  }

  extendsCategoryPackagetour(event: any): void {
    this.getPackageCategory();
    this.item.patchValue({
      packagetourcategory_id: event.id
    });
  }
}
